import React from 'react';
import Sliders from './../sliders/Sliders';
import Collections from '../collections/Collections';
import LatestProducts from '../latest/LatestProducts';
import FeaturedProducts from './shop/FeaturedProducts';
import Brands from './../brands/Brands';
import NoStoreFrontData from '../../widgets/splash/NoStoreFrontData';
import RecomandedProducts from './shop/RecomandedProducts';
import { useSelector } from 'react-redux';
const StoreFront = () => {
    const storeFrontData = useSelector((state) => state.app.storeData);
    return (
        <div>
            {
                storeFrontData.length === 0 &&
                <NoStoreFrontData />
            }
            {
                storeFrontData.length !== 0 &&
                <div>
                    <Sliders />
                    <LatestProducts />
                    <Collections />
                    <FeaturedProducts />
                    <RecomandedProducts />
                    <Brands />
                </div>
            }
        </div>
    );
}
export default StoreFront;